/**
 * Parse preset string to ImageTransformOptions
 * Format: rw400h300q80gc
 * - r = resize
 * - w400 = width 400
 * - h300 = height 300
 * - q80 = quality 80
 * - g = format webp (g = webp, j = jpeg, p = png)
 * - c = cover fit (c = cover, i = inside, s = contain/scale-down)
 */

export type PresetFormat = 'webp' | 'avif' | 'jpeg' | 'png';
export type PresetFit = 'cover' | 'contain' | 'fill' | 'inside' | 'outside';

export interface PresetOptions {
  width?: number;
  height?: number;
  quality?: number;
  format?: PresetFormat;
  fit?: PresetFit;
}

export function parsePresetToOptions(preset?: string): PresetOptions {
  if (!preset || !preset.trim()) return {};

  const widthMatch = preset.match(/w(\d+)/);
  const heightMatch = preset.match(/h(\d+)/);
  const qualityMatch = preset.match(/q(\d+)/);
  const formatMatch = preset.match(/[gjp]/);
  const fitMatch = preset.match(/[cis]/);

  let width: number | undefined;
  let height: number | undefined;
  let quality: number | undefined;
  let format: PresetFormat | undefined;
  let fit: PresetFit | undefined;

  if (widthMatch) width = parseInt(widthMatch[1], 10);
  if (heightMatch) height = parseInt(heightMatch[1], 10);
  if (qualityMatch) quality = parseInt(qualityMatch[1], 10);

  if (formatMatch) {
    const f = formatMatch[0];
    if (f === 'g') format = 'webp';
    else if (f === 'j') format = 'jpeg';
    else if (f === 'p') format = 'png';
  }

  if (fitMatch) {
    const f = fitMatch[0];
    if (f === 'c') fit = 'cover';
    else if (f === 'i') fit = 'inside';
    else if (f === 's') fit = 'contain';
  }

  return { width, height, quality, format, fit };
}
